module.exports = __webpack_public_path__ + "img/1508934371.450420b8.jpg";